/* eslint-disable */
import { envDomain } from '@/common/contact-selector/utils/domainConfig';
function getGroupNicheConfig(params) {
  return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/b2b/selector/getTroopDetail`, params);
}

export default function(params) {
  return new Promise((resolve, reject) => {
    if (params.ids && params.ids.length){
        let ids = [];
      params.ids.forEach((ele)=>{
          if(typeof ele === 'string'){
              ids.push(parseFloat(ele));
          }else{
              ids.push(ele);
          }
      })
      getGroupNicheConfig({
          groupList: [
              {
                  groupName: '我的QQ群',
                  groupCode: ids
              }
          ]
      }).then(
          res => {
              if (window.parseInt(res.code) === 0 && res.data && res.data.records && res.data.records.length) {
                  let list = res.data.records[0].groupList.map(x=>{
                      return {
                          ...x,
                          id: x.uin+''
                      }
                  })
                  resolve(list);
              } else {
                  resolve([]);
              }
          },
          err => {
              reject(err);
          }
      );
    }else{
        resolve([]);
    }

  });
}
